import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCK3ouH-t0roM8nt2RjssOZnaFGUGxCUds",
  authDomain: "estimator-7acdc.firebaseapp.com",
  databaseURL: "https://estimator-7acdc-default-rtdb.firebaseio.com",
  projectId: "estimator-7acdc",
  storageBucket: "estimator-7acdc.firebasestorage.app",
  messagingSenderId: "918769137528",
  appId: "1:918769137528:web:2a41122f194ec10bb73a8d",
  measurementId: "G-B82EY8HF3Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
// Connect to the named Firestore database "estimator1022"
export const db = getFirestore(app, "estimator1022");

// Export config for secondary app instances
export { firebaseConfig };
export { app };
export default app;

